import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import {useMediaQuery} from '../../hooks/useMediaQuery';

import ValueCard from './ValueCard';
import styles from './styles/about-03.module.css';

import {ReactComponent as BackgroundDownImg} from '../../assets/about03/background-down.svg';
import {ReactComponent as BackgroundUpImg} from '../../assets/about03/background-up.svg';
import {ReactComponent as DesktopDownImg} from '../../assets/about03/desktop-down.svg';
import {ReactComponent as DesktopUpImg} from '../../assets/about03/desktop-up.svg';

const backgroundUpMotion = {
    initial: { opacity: 0, y: '-100%' },
    animate: { 
        opacity: 1,
        y: 0, 
        transition: { ease: 'easeOut', duration: 0.2 } 
    }
};

const backgroundDownMotion = {
    initial: { opacity: 0, y: '100%' },
    animate: { 
        opacity: 1,
        y: 0, 
        transition: { ease: 'easeOut', duration: 0.2, delay: 1.4 }
    }
};

export default function About03() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const desktopOver = useMediaQuery('(min-width: 1441px)');

    const ref = useRef(null);

    const isInView = useInView(ref, {
        once: true,
        amount: 0.3,
        margin: '-100px 0px'
    });

    const growMap = [
        { 
            id: 1, 
            title: '명확한 소통', 
            content: '명확한 언어 습관과 투명한 정보 공유로 팀의 속도와 효율성을 높입니다. \'참치마요\'처럼 참지 말고, 열린 마음으로 명확하게 소통하고 기록하여 팀의 속도를 높입니다.',
        },
        { 
            id: 2,
            title: '학습과 도전',
            content: '끊임없는 배움을 통해 성장합니다. 새로운 도전을 두려워하지 않고, 실패를 통해 더 나은 해답을 찾아갑니다.'
        }
    ];

    const contributeMap = [
        { 
            id: 1, 
            title: '주도적 기여', 
            content: <p>자신의 역할을 넘어 조직의 성공을 위해 능동적으로 행동합니다.<br />도전적인 상황에서도 책임감을 가지고 앞장섭니다.</p>
        },
        { 
            id: 2,
            title: '고객 중심',
            content: <p>진정으로 고객의 입장이 되어 그들의 문제를 해결합니다.<br />고객이 사랑하는 제품을 만드는 것이 우리의 사명입니다.</p>
        }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.background}>
                <motion.div
                    initial='initial'
                    animate={isInView ? 'animate' : 'initial'}
                    variants={backgroundUpMotion}
                >
                    {!desktopOver && <BackgroundUpImg preserveAspectRatio='none' />}
                    {desktopOver && <DesktopUpImg preserveAspectRatio='none' />}
                </motion.div>
                <motion.div
                    initial='initial'
                    animate={isInView ? 'animate' : 'initial'}
                    variants={backgroundDownMotion}
                >
                    {!desktopOver && <BackgroundDownImg preserveAspectRatio='none' />}
                    {desktopOver && <DesktopDownImg preserveAspectRatio='none' />}
                </motion.div>
            </div>
            <div className={styles.container} ref={ref}>
                <p className={styles.title}>핵심 가치</p>
                <div className={styles.boxCard}>
                    <ValueCard
                        value='성장'
                        description={mobileMedium ? <>"4배속 성장"을 통해 매일 한 걸음씩 발전하며<br />혁신합니다</> : '"4배속 성장"을 통해 매일 한 걸음씩 발전하며 혁신합니다.'}
                        valueMap={growMap}
                        isFirst={true}
                    />
                    <ValueCard
                        value='기여'
                        description={mobileMedium ? <>고객에게 진정한 쓰임이 되는 가치를 만들며,<br />산업 및 사회 발전에 기여합니다.</> : '고객에게 진정한 쓰임이 되는 가치를 만들며, 산업 및 사회 발전에 기여합니다.'}
                        valueMap={contributeMap}
                        isFirst={false}
                    />
                </div>
            </div>
        </div>
    );
}
